/**
 * Rider-facing labels.
 *
 * `pack_label` is resolved by the backend (routes_delivery._hydrate_pack_labels
 * / delivery_labels.pack_label): the pack actually ordered — the row's own
 * variant snapshot, else its product/variant for older rows. It is empty when
 * nothing is known, in which case only the product name is shown; a size is
 * never invented here.
 */
export function productLine(d) {
  const name = (d?.product_name || "").trim() || "Item";
  const label = (d?.pack_label || "").trim();
  const qty = d?.quantity ?? 1;
  return label ? `${name} — ${label} × ${qty}` : `${name} × ${qty}`;
}

/** Same, for a pack-summary / apartment-summary item (total quantity). */
export function packItemLine(it) {
  return productLine({ product_name: it?.product_name, pack_label: it?.pack_label, quantity: it?.total_quantity });
}

/** Stable React key for per-variant summary items. */
export function packItemKey(it) {
  return `${it?.product_id || "p"}:${it?.variant_id || it?.pack_label || "default"}`;
}

/** Case-insensitive apartment search over name + address. */
export function filterApartmentSummaries(list, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return list || [];
  return (list || []).filter((a) =>
    `${a?.apartment_name || ""} ${a?.address || ""}`.toLowerCase().includes(q));
}
